import { Box, Drawer, Typography } from "@mui/material";
import { useState } from "react";
import MReviewSection from "./MReviewSection";
import MInfoSection from "./MInfoSection";
import { MLocationSection } from "./MLocationSection";
import { MPhotographSection } from "./MPhotographSection";

export function MTabSection({ sectionRef }: { sectionRef: any }) {
  const [openLocation, setOpenLocation] = useState(false);
  const [openReview, setOpenReview] = useState(false);
  const [openInfo, setOpenInfo] = useState(false);

  const handleClickScroll = () => {
    sectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleCloseLocation = () => {
    setOpenLocation(false);
  };

  const handleCloseInfo = () => {
    setOpenInfo(false);
  };

  const handleCloseReview = () => {
    setOpenReview(false);
  };

  

  return (
    <>
      <Box
        display="flex"
        width="100%"
        borderBottom={1}
        borderColor="divider"
        py={1.5}
        bgcolor="white"
      >
        <Box
          display="flex"
          flex={1}
          justifyContent="center"
          onClick={handleClickScroll}
        >
          <Typography variant="body2">予約</Typography>
        </Box>
        <Box
          display="flex"
          flex={1}
          justifyContent="center"
          onClick={() => setOpenReview(true)}
        >
          <Typography variant="body2">クチコミ</Typography>
        </Box>
        <Box
          display="flex"
          flex={1}
          justifyContent="center"
          onClick={() => setOpenLocation(true)}
        >
          <Typography variant="body2">アクセス</Typography>
        </Box>
        <Box
          display="flex"
          flex={1}
          justifyContent="center"
          onClick={() => setOpenInfo(true)}
        >
          <Typography variant="body2">店舗情報</Typography>
        </Box>
      </Box>

      <Drawer
        open={openLocation}
        onClose={handleCloseLocation}
        anchor="right"
        variant="temporary"
        PaperProps={{
          sx: {
            width: "100%",
            maxWidth: "100%",
          },
        }}
      >
        <MLocationSection handleClose={handleCloseLocation} />
      </Drawer>

      <Drawer
        open={openReview}
        onClose={handleCloseReview}
        anchor="right"
        variant="temporary"
        PaperProps={{
          sx: {
            width: "100%",
            maxWidth: "100%",
          },
        }}
      >
        <MReviewSection handleClose={handleCloseReview} />
      </Drawer>

      <Drawer
        open={openInfo}
        onClose={handleCloseInfo}
        anchor="right"
        variant="temporary"
        PaperProps={{
          sx: {
            width: "100%",
            maxWidth: "100%",
          },
        }}
      >
        <MInfoSection handleClose={handleCloseInfo} />
      </Drawer>
    </>
  );
}
